import { toast } from "sonner";

const API = process.env.REACT_APP_BACKEND_URL || "";

/**
 * Abre a janela de conexão da Meta para ESTA loja. O servidor devolve o
 * endereço com um bilhete assinado (vale 30 minutos) que diz de qual loja é a
 * conexão; sem ele a janela não conecta nada. A janela é aberta já no clique,
 * vazia, porque o navegador bloqueia pop-up aberto depois de uma espera.
 */
export async function abrirConexaoOficial() {
  const janela = window.open("", "wa_oficial", "width=620,height=780");
  try {
    const r = await fetch(`${API}/api/whatsapp/oficial/conectar`, {
      method: "POST",
      headers: { Authorization: `Bearer ${localStorage.getItem("token") || ""}` },
    });
    const d = await r.json().catch(() => ({}));
    if (!r.ok || !d?.url) throw new Error(d?.detail || "Não foi possível abrir a conexão agora.");
    if (janela) janela.location.href = d.url;
    else window.open(d.url, "wa_oficial", "width=620,height=780");
  } catch (e) {
    janela?.close();
    toast.error(e.message || "Não foi possível abrir a conexão agora.");
  }
}
